import { render, staticRenderFns } from "./NavDesktopProductsSubmenu.vue?vue&type=template&id=1125ef6a&scoped=true"
import script from "./NavDesktopProductsSubmenu.vue?vue&type=script&lang=js"
export * from "./NavDesktopProductsSubmenu.vue?vue&type=script&lang=js"
import style0 from "./NavDesktopProductsSubmenu.vue?vue&type=style&index=0&id=1125ef6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1125ef6a",
  null
  
)

export default component.exports